module.exports = __webpack_public_path__ + "static/grid-around-a325c075f4b8bf51afa8565981fa509b.png";